import { GetViewportSize } from "./GetViewportSize";
import { RectSize } from "./RectSize";

export enum ScreenOrientationType {
    PORTRAIT,// = "portrait",
    LANDSCAPE,// = "landscape",
}

export function GetOrientationFromRect(windowRect?:RectSize): ScreenOrientationType
{
    if (windowRect == undefined) {
        windowRect = GetViewportSize();
    }
    return GetOrientation(windowRect.width, windowRect.height);
}

export function GetOrientation(width: number, height: number): ScreenOrientationType
{
    return width > height ? 
        ScreenOrientationType.LANDSCAPE : 
        ScreenOrientationType.PORTRAIT;
}